enum SCENE_OBJECT_TYPE {
  GameBoy = 'GAME_BOY',
  Cartridges = 'CARTRIDGES',
  Background = 'BACKGROUND',
}

export { SCENE_OBJECT_TYPE };
